module.exports = __webpack_public_path__ + "img/icon_sent-mail2.631b69af.png";